import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/$/, "");

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "de",
    supportedLngs: ["de", "en", "zh"],
    load: "languageOnly",
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: `${publicUrl}/locales/{{lng}}.json`,
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
